import { render } from "./IconContact.vue?vue&type=template&id=c37ee91e"
import script from "./IconContact.vue?vue&type=script&lang=js"
export * from "./IconContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__